import { useLDFlag } from 'launchdarkly-vue-client-sdk';
import { defineStore } from 'pinia';
import { LD_FLAGS } from '@/constants/constants';

export const useLaunchDarklyStore = defineStore('launchDarkly', () => {
  return {
    langchainAppCrudEnabled: useLDFlag(
      LD_FLAGS.LANGCHAIN_APP_FLOWS_CRUD_ENABLED,
      false,
    ),
  };
});
